import * as types from "../../constants";

export default function reducer(state = {}, actions) {
  //console.log("actions", actions);
  switch (actions.type) {
    case types.FETCH_DEPLOYMENT_TYPE_PENDING:
      return {
        ...state,
        pending: true,
      };
    case types.FETCH_DEPLOYMENT_TYPE_SUCCESS:
      return {
        ...state,
        pending: false,
        deploymentType: actions.payload.data,
      };
    case types.FETCH_DEPLOYMENT_TYPE_ERROR:
      return {
        ...state,
        pending: false,
        error: actions.error,
      };
    default:
      return state;
  }
}
